import { useDiaryByIdQuery } from "@/features/diaries/api";

import { extractTrackerById } from "../../diaries/services/extractTrackerById";

const useExtractTracker = (diaryId: string, trackerId: string) => {
	const { data: diary } = useDiaryByIdQuery(diaryId);
	if (!diary) return;
	return extractTrackerById(diary, trackerId);
};

export default useExtractTracker;
